export const FIELD =
  'h-[42px] rounded-[9px] border-[1.5px] px-[13px] text-[13px] md:text-[12px] bg-white';

export const LABEL = 'text-xs font-semibold text-[#48536A]';

export const SUBMIT = 'h-11 w-full rounded-[9px] text-md font-semibold mt-4 hover:cursor-pointer';
